<div class="cm-section-title">
    <ng-content select="[cm-section-title]"> </ng-content>
</div>
<div class="cm-section-content">
    <ng-content select="[cm-section]"> </ng-content>
</div>
